export default "__VITE_ASSET__eJFiR0Q$__"